module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-ilsole24ore.45f78b9f45a3900b419c4e63853c1c86.png";